import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects', 'put'>;
type ResponseBody = OASOutput<O, '/api/projects', 'put'>;

type Params = {
  projectId: number;
  newName: string;
};

type Result = {
  id: number;
  guid: string;
  name: string;
  thumbnailUrl: string;
  tagGuids: string[];
};

export const updateProjectPropertiesFactory = (apiClient: ApiClient) => {
  const updateProjectProperties = async (projectId: number, newName: string) => {
    const requestBody = mapInputToRequestBody({ projectId, newName });
    const response = await apiClient['/api/projects'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        projectId: input.projectId,
        newName: input.newName,
        watermark: null,
        courseFeedbackEmailAddress: null,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      guid: response.guid,
      name: response.name,
      thumbnailUrl: response.thumbnailUrl,
      tagGuids: response.tagGuids,
    };
  };

  return updateProjectProperties;
};
